import { render, staticRenderFns } from "./LoginSMSCodeCheck.vue?vue&type=template&id=2bb8ed5c&scoped=true&"
import script from "./LoginSMSCodeCheck.vue?vue&type=script&lang=js&"
export * from "./LoginSMSCodeCheck.vue?vue&type=script&lang=js&"
import style0 from "./LoginSMSCodeCheck.vue?vue&type=style&index=0&id=2bb8ed5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8ed5c",
  null
  
)

export default component.exports